<template>
	<div>
		<b-card class="card-overview">
            <div slot="header">
                <i class="fa fa-align-justify mr-1"></i>
                <strong>{{ $t(name) }}</strong>
                <div class="card-actions" v-if="link.length || hasButtonAction">
                    <router-link :to="link" :title="$t('New ' + name)" v-if="link.length">
                        <!-- <small class="text-muted">{{ $t('New ' + name) }}</small> -->
                        <font-awesome-icon icon="plus" />
                    </router-link>
                    <button v-else @click="handleClickButtonAction">
                    	<font-awesome-icon icon="plus" />
                    </button>
                </div>
            </div>
			<b-form-group v-if="typeof this.search === 'function'">
				<b-input-group>
					<!-- Attach Left button -->
					<b-form-input
						v-model="keywordsvm"
						type="text"
						:placeholder="$t(this.searchPlaceholder || 'Search') + '...'"
					></b-form-input>
					<b-input-group-append>
						<b-button @click="search_keywords" variant="primary">
							{{ $t('Search') }}
							<i class="fa fa-search ml-1"></i>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>
			<slot />
		</b-card>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			default: '',
		},
		link: {
			default: '',
		},
		keywords: {
			default: '',
		},
		search: {
			default: null,
		},
		searchPlaceholder: {
			default: null,
		},
		hasButtonAction: {
			default: false
		},
	},

	data() {
		return {
			// keywordsvm: ""
		}
	},

	methods: {
		search_keywords() {
			if (typeof this.search === 'function') {
				return this.search()
			}
			console.info('Search Method Undefined! @' + this.name)
		},
		handleClickButtonAction() {
			this.$emit('clickAction')
		}
	},

	computed: {
		keywordsvm: {
			set(value) {
				this.$emit('keywordsChange', value)
			},
			get() {
				return this.keywords
			},
		},
	},
}
</script>
